import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { Alert, Button, Card, CardBody, CardFooter } from "reactstrap";
import { toastr } from "react-redux-toastr";

const DeleteAccount = ({ selected, onDelete }) => {
  const confirmDelete = () => {
    toastr.confirm("Are you sure you want to delete your account?", {
      okText: "Delete Account",
      onOk: onDelete,
    });
  };

  return (
    selected === "delete" && (
      <Card>
        <CardBody>
          <h3>Delete Account</h3>

          <Alert color="danger" className="alert-outline">
            <div className="alert-icon d-flex align-items-center">
              <FontAwesomeIcon icon={faExclamationTriangle} size="2x" />
            </div>

            <div className="alert-message">
              <p>Are you sure you want to delete your account?</p>
              <p>This action cannot be undone.</p>
            </div>
          </Alert>
        </CardBody>

        <CardFooter className="text-right">
          <Button color="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </CardFooter>
      </Card>
    )
  );
};

export default DeleteAccount;
